document.addEventListener('DOMContentLoaded', function() {
  // Variant tip butonları için event listener
  const typeButtons = document.querySelectorAll('.variant-type-btn');
  if (typeButtons.length > 0) {
    typeButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        // Aktif buton sınıfını güncelle
        typeButtons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        // İlgili variant grubunu göster
        const type = this.dataset.type;
        document.querySelectorAll('.variant-group').forEach(group => {
          if (group.id === `${type}-variants`) {
            group.classList.remove('hidden');
          } else {
            group.classList.add('hidden');
          }
        });

        // Diğer gruptaki quantity değerlerini sıfırla
        const hiddenGroup = document.querySelector('.variant-group.hidden');
        if (hiddenGroup) {
          hiddenGroup.querySelectorAll('input[name="quantity"]').forEach(input => {
            input.value = 0;
          });
        }

        // Yeni aktif gruptaki ilk style butonunu aktif et
        const activeGroup = document.getElementById(`${type}-variants`);
        if (activeGroup) {
          const styleButtons = activeGroup.querySelectorAll('.style-btn');
          if (styleButtons.length > 0) {
            styleButtons.forEach(styleBtn => styleBtn.classList.remove('active'));
            styleButtons[0].classList.add('active');
            
            // İlgili variant satırlarını göster/gizle
            const selectedStyle = styleButtons[0].dataset.style;
            activeGroup.querySelectorAll('.variant-row').forEach(row => {
              if (row.classList.contains(`variant-style-${selectedStyle}`)) {
                row.classList.remove('hidden');
              } else {
                row.classList.add('hidden');
              }
            });
          }
        }
      });
    });
  }

  // Style butonları için event listener
  const styleButtons = document.querySelectorAll('.style-btn');
  if (styleButtons.length > 0) {
    styleButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        // Aktif buton sınıfını güncelle
        const activeGroup = this.closest('.variant-group');
        activeGroup.querySelectorAll('.style-btn').forEach(b => {
          b.classList.remove('active');
        });
        this.classList.add('active');

        // İlgili variant satırlarını göster/gizle
        const selectedStyle = this.dataset.style;
        activeGroup.querySelectorAll('.variant-row').forEach(row => {
          if (row.classList.contains(`variant-style-${selectedStyle}`)) {
            row.classList.remove('hidden');
          } else {
            row.classList.add('hidden');
          }
        });

        // Gizlenen satırlardaki quantity değerlerini sıfırla
        activeGroup.querySelectorAll('.variant-row.hidden input[name="quantity"]').forEach(input => {
          input.value = 0;
        });
      });
    });
  }

  // Miktar butonları için event listener
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const input = this.parentElement.querySelector('input');
      const currentValue = parseInt(input.value) || 0;
      
      if (this.classList.contains('minus')) {
        if (currentValue > 0) input.value = currentValue - 1;
      } else {
        input.value = currentValue + 1;
      }
    });
  });

  // Add to cart butonu için event listener
  const addToCartButton = document.getElementById('add-selected-to-cart');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', async function() {
      const errorMessage = document.querySelector('.error-message');
      const activeGroup = document.querySelector('.variant-group:not(.hidden)');
      const forms = activeGroup.querySelectorAll('.variant-form');
      let hasItems = false;
      
      // Önce tüm ürünleri topla
      const itemsToAdd = [];
      forms.forEach(form => {
        const quantity = parseInt(form.querySelector('input[name="quantity"]').value) || 0;
        if (quantity > 0) {
          hasItems = true;
          itemsToAdd.push({
            id: form.querySelector('input[name="id"]').value,
            quantity: quantity
          });
        }
      });

      if (!hasItems) {
        errorMessage.textContent = "Please select at least one item to add to cart";
        errorMessage.classList.add('show');
        return;
      }

      errorMessage.classList.remove('show');
      
      try {
        // Tüm ürünleri tek seferde ekle
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: itemsToAdd
          })
        });

        if (!response.ok) {
          const result = await response.json();
          errorMessage.textContent = result.description || "Some items are no longer available";
          errorMessage.classList.add('show');
          return;
        }

        // Cart drawer'ı güncelle
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          // Cart drawer'ı yeniden yükle
          fetch('/?section_id=cart-drawer')
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const cartDrawer = parser.parseFromString(html, 'text/html')
                .querySelector('#cart-drawer-container');
              
              if (cartDrawer && document.querySelector('#cart-drawer-container')) {
                document.querySelector('#cart-drawer-container').innerHTML = cartDrawer.innerHTML;
              }
            });
        }

        // Cart updated event'ini dispatch et
        document.dispatchEvent(new CustomEvent('cart:updated'));

        // Başarılı mesajını göster
        const originalText = addToCartButton.textContent;
        addToCartButton.textContent = 'Added to cart!';
        setTimeout(() => {
          addToCartButton.textContent = originalText;
        }, 2000);

      } catch (error) {
        console.error('Error adding to cart:', error);
        errorMessage.textContent = "Error adding items to cart";
        errorMessage.classList.add('show');
      }
    });
  }
});